import { set, toggle } from '@/utils/vuex'

export default {
  setDrawer: set('drawer'),
  setBreadcrumbs: set('breadcrumbs'),
  toggleDrawer: toggle('drawer'),
  addSnackbar (state, params) {
    if (typeof params === 'string') {
      params = { message: params }
    }
    state.snackbarState = true
    state.snackbarMessage = params.message
    state.snackbarColor = params.color
  }
}
